import { createFileRoute } from '@tanstack/react-router';
import { MerchantsPage } from '../../features/merchants/MerchantsPage.jsx';

export const Route = createFileRoute('/_app/merchants/')({ component: MerchantsPage });
